import { createFileRoute } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { useAudit } from '@/hooks/use-audit';
import { relativeTime } from '@/lib/format';

export const Route = createFileRoute('/_authenticated/admin/audit')({
  component: AuditPage,
});

function AuditPage() {
  const { data, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage } = useAudit();
  const all = data?.pages.flatMap((p) => p.entries) ?? [];

  return (
    <div className="mx-auto max-w-5xl px-6 py-8 animate-fade-up">
      <header className="mb-6">
        <h1 className="mb-1 text-2xl font-semibold tracking-tight">Audit log</h1>
        <p className="text-sm text-text-muted">All admin actions, newest first.</p>
      </header>

      {isLoading ? (
        <Skeleton className="h-96 w-full" />
      ) : (
        <div className="rounded-lg border border-border bg-bg-surface divide-y divide-border">
          {all.map((e: any) => (
            <div key={e.id} className="flex items-center gap-4 p-3">
              <Badge variant="outline" className="font-mono text-[10px]">{e.action}</Badge>
              <div className="min-w-0 flex-1">
                <span className="text-sm">{e.actor_email ?? e.actor_id}</span>
                {e.resource_type && (
                  <span className="ml-2 text-xs text-text-muted">
                    {e.resource_type} <span className="font-mono">{e.resource_id}</span>
                  </span>
                )}
              </div>
              <div className="text-xs text-text-muted font-mono">{relativeTime(e.created_at * 1000)}</div>
            </div>
          ))}
        </div>
      )}

      {hasNextPage && (
        <div className="mt-4 text-center">
          <Button variant="outline" onClick={() => fetchNextPage()} disabled={isFetchingNextPage}>
            {isFetchingNextPage ? 'Loading…' : 'Load more'}
          </Button>
        </div>
      )}
    </div>
  );
}
